import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  NumberFormats,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { AxisLabelSortOrder } from '../../types';

export type EchartsHorizontalBarFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric?: string;
    showLabels: boolean;
    combineMetrics: boolean;
    colorScheme?: string;
    metrics: QueryFormMetric[];
    sortLabels: AxisLabelSortOrder;
    numberFormat: string;
};

export interface EchartsHorizontalBarChartProps
  extends ChartProps<EchartsHorizontalBarFormData> {
  formData: EchartsHorizontalBarFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsHorizontalBarFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  combineMetrics: false,
  sortLabels: AxisLabelSortOrder.None,
  numberFormat: NumberFormats.ORIGINAL
};

export interface HorizontalBarChartTransformedProps {
  formData: EchartsHorizontalBarFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
  ownState: any;
}